var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Card, Checkbox, Divider, FormControlLabel, Grid, List, ListItem, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get } from "../../../../api/api";
import { DeclinedJobReasonListUrl, RepairTypeList, downloadPreviousAttachmentComplaintURL, getDeclinedCustomerComplaintsUrl, getSavedJobItemsUrl, upsertPreviousCustomerComplaintAppointment, upsertPreviousCustomerComplaintEstimate, upsertPreviousCustomerComplaintInspection } from "../../../../api/url";
import { ArrowDownIcon, ArrowUPIcon, BlueDropdownIcon, BlueUpIcon } from "../../../../assets/images";
import { AudioPlayer, MuiStack } from "../../../../components";
import { MuiImagePopUp } from "../../../../components/atoms/imageDialogBox";
import { MuiLoaderButton } from "../../../../components/atoms/loaderButton";
import ViewAllImagePopUp from "../../../../components/atoms/viewAllImagePopUp";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../../constants";
import { downloadAttachment, showLoader, showNotification } from "../../../../redux/commonSlice";
import { getByIdAPI, getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { gray } from "../../../../theme/palette";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import useAnalyticsEventTracker from "../../../../utils/useAnalyticsEventTracker";
import { sortImagesByTimeStamp } from "../../../../utils/utils";
var DeclinedCustomerComplaint = function (props) {
    var _customerComplaint$fi;
    var parentModuleName = props.parentModuleName, jobCount = props.jobCount, currentJobCardData = props.currentJobCardData, jobCardID = props.jobCardID, showGroupItems = props.showGroupItems, disabledPreviousDeclined = props.disabledPreviousDeclined;
    var _a = useParams(), estimateId = _a.estimateId, appointmentId = _a.appointmentId, inspectionId = _a.inspectionId;
    var _b = useState(false), isOpenSection = _b[0], setIsOpenSection = _b[1];
    var _c = useState([]), customerComplaint = _c[0], setcustomerComplaint = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var _e = useState([]), serviceTypeList = _e[0], setServiceTypeList = _e[1];
    var _f = useState(true), disableSaveBtn = _f[0], setDisableSaveBtn = _f[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _g = useState(false), viewImages = _g[0], setViewImages = _g[1];
    var _h = useState([]), viewAllImagesList = _h[0], setViewAllImagesList = _h[1];
    var _j = useState(false), openImagePopup = _j[0], setOpenImagePopup = _j[1];
    var _k = useState(""), imageURL = _k[0], setImageURL = _k[1];
    var trackButtonClick = useAnalyticsEventTracker("DeclinedCustomerComplaint");
    var dispatch = useAppDispatch();
    var savedcustomerComplaint = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }).savedcustomerComplaint;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    useEffect(function () {
        if (jobCardID) {
            setIsOpenSection(false);
        }
    }, [jobCardID]);
    useEffect(function () {
        getRejectRemarkList();
        getServiceTypeList();
    }, []);
    useEffect(function () {
        if (jobCardID !== "" && jobCardID !== undefined) {
            getcustomerComplaint();
        }
    }, [jobCardID]);
    var downloadAttachmentsForDeclinedComplaints = function (complaintItem) { return __awaiter(void 0, void 0, void 0, function () {
        var _complaintItem$ImageA, _complaintItem$ImageA2, imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, imagesDownloadPromise, audioAttachmentsUrlWithMediaType2, audioDownloadPromise, sortedImages, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = (_complaintItem$ImageA = complaintItem.ImageAttachments) === null || _complaintItem$ImageA === void 0 ? void 0 : _complaintItem$ImageA.filter(function (item) { return item.MediaType === 1; });
                    imagesDownloadPromise = imageAttachmentsUrlWithMediaType1 === null || imageAttachmentsUrlWithMediaType1 === void 0 ? void 0 : imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var blobUrl, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, downloadPreviousAttachmentComplaintURL)];
                                case 2:
                                    blobUrl = _a.sent();
                                    imageAttachementURLs.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        blobUrl: blobUrl
                                    }));
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.error(error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = (_complaintItem$ImageA2 = complaintItem.ImageAttachments) === null || _complaintItem$ImageA2 === void 0 ? void 0 : _complaintItem$ImageA2.filter(function (item) { return item.MediaType === 2; });
                    audioDownloadPromise = audioAttachmentsUrlWithMediaType2 === null || audioAttachmentsUrlWithMediaType2 === void 0 ? void 0 : audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var blobUrl, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, downloadPreviousAttachmentComplaintURL)];
                                case 2:
                                    blobUrl = _a.sent();
                                    console.log("blobUrl", blobUrl);
                                    audioAttachementURLs.push(blobUrl);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(imagesDownloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(audioDownloadPromise)];
                case 3:
                    _a.sent();
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs);
                    return [2 /*return*/, {
                            imageAttachementURLs: sortedImages,
                            audioAttachementURLs: audioAttachementURLs
                        }];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, {
                            imageAttachementURLs: [],
                            audioAttachementURLs: []
                        }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getcustomerComplaint = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d, _currentJobCardData$d2, _response$payload, response, _response$payload2, customerComplaints, updatedList_1, listPromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "declinedCustomerComplaints",
                        url: getDeclinedCustomerComplaintsUrl,
                        request: {
                            VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d = currentJobCardData.data) === null || _currentJobCardData$d === void 0 ? void 0 : _currentJobCardData$d.VinNo,
                            ParentId: jobCardID,
                            OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d2 = currentJobCardData.data) === null || _currentJobCardData$d2 === void 0 ? void 0 : _currentJobCardData$d2.OrganizationId
                        }
                    }))];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) === 200)) return [3 /*break*/, 3];
                    customerComplaints = __spreadArray([], (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data), true);
                    updatedList_1 = [];
                    listPromise = customerComplaints.map(function (complaintItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var _downloadedAttachment, _downloadedAttachment2, downloadedAttachments;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, downloadAttachmentsForDeclinedComplaints(complaintItem)];
                                case 1:
                                    downloadedAttachments = _a.sent();
                                    updatedList_1.push(_objectSpread(_objectSpread({}, complaintItem), {}, {
                                        imageAttachementURLs: (_downloadedAttachment = downloadedAttachments.imageAttachementURLs) !== null && _downloadedAttachment !== void 0 ? _downloadedAttachment : [],
                                        audioAttachment: ((_downloadedAttachment2 = downloadedAttachments.audioAttachementURLs) === null || _downloadedAttachment2 === void 0 ? void 0 : _downloadedAttachment2.length) > 0 ? downloadedAttachments.audioAttachementURLs[0] : ""
                                    }));
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(listPromise)];
                case 2:
                    _a.sent();
                    setcustomerComplaint(updatedList_1);
                    getSavedcustomerComplaint();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getSavedcustomerComplaint = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload3, _response$payload4, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "savedcustomerComplaint",
                        url: getSavedJobItemsUrl,
                        request: {
                            PreJobCardDocumentId: estimateId || appointmentId || inspectionId
                        }
                    }))];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && _response$payload3.success && (response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var updateData = function (item, type) {
        var _data = customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.map(function (i, index) {
            if ((item === null || item === void 0 ? void 0 : item.ComplaintId) === (i === null || i === void 0 ? void 0 : i.ComplaintId)) {
                if (type === "reasonItem") {
                    trackButtonClick("ButtonClickEvent", "ReasonClick", undefined);
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                if (type === "groupItem") {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isOpen: !(i !== null && i !== void 0 && i.isOpen)
                    });
                    return _i;
                }
            }
            else {
                return i;
            }
        });
        setcustomerComplaint(_data);
    };
    var onGroupChange = function (e, selectedOption) {
        setcustomerComplaint(function (prevComplaints) { return prevComplaints.map(function (option) { return option.ComplaintId === selectedOption.ComplaintId ? _objectSpread(_objectSpread({}, option), {}, {
            isSelected: !option.isSelected
        }) : option; }); });
        setDisableSaveBtn(false);
    };
    var getReason = function (option) {
        var i = rejectReasonRemarkList === null || rejectReasonRemarkList === void 0 ? void 0 : rejectReasonRemarkList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId); });
        if (i)
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2"
            }, i === null || i === void 0 ? void 0 : i.Name), /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                color: "text.secondary"
            }, option.Remarks));
    };
    var upsertcustomerComplaint = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d3, _response$payload5, _response$payload6, filterList, payload, URL, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Declined_CustomerComplaint_Save", undefined);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    filterList = customerComplaint.filter(function (item) { return item.isSelected; });
                    payload = {
                        InstallBaseId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d3 = currentJobCardData.data) === null || _currentJobCardData$d3 === void 0 ? void 0 : _currentJobCardData$d3.InstallBaseId,
                        JobItems: filterList.map(function (complaint) { return ({
                            SystemName: "CustomerVoiceToJobItem",
                            ComplaintGroupAssociationId: complaint.ComplaintGroupAssociationId,
                            ComplaintGroupChildAssociationId: complaint.ComplaintGroupChildAssociationId,
                            Value: "1",
                            Comments: complaint.Comments,
                            Remarks: complaint.Remarks,
                            DeclinedJobReasonId: complaint.DeclinedJobReasonId,
                            ComplaintId: complaint.ComplaintId,
                            ImageAttachments: complaint.ImageAttachments.map(function (image) { return ({
                                AttachmentId: image.AttachmentId,
                                MediaType: image.MediaType,
                                SystemName: "CustomerVoiceToJobItem"
                            }); }),
                            ComplaintAssociations: __spreadArray(__spreadArray([], complaint.ComplaintAssociations.Labour.map(function (labour) { return ({
                                Quantity: labour.Quantity || 1,
                                SystemName: "Labour",
                                ChildId: labour.ChildId,
                                ServiceGroupId: complaint.ComplaintId,
                                DeclineDateTime: new Date().toISOString(),
                                Remarks: labour.Remarks || "",
                                ServiceTypeId: labour.ServiceTypeId,
                                DeclinedJobReasonId: complaint.DeclinedJobReasonId,
                                ServiceDetailType: 4,
                                ParentSystemName: "RevisedEstimate",
                                Price: labour.Price || null
                            }); }), true), complaint.ComplaintAssociations.Part.map(function (part) { return ({
                                Quantity: part.Quantity || 1,
                                SystemName: "Product",
                                ChildId: part.ChildId,
                                ServiceGroupId: complaint.ComplaintId,
                                DeclineDateTime: new Date().toISOString(),
                                Remarks: part.Remarks || "",
                                ServiceTypeId: part.ServiceTypeId,
                                DeclinedJobReasonId: complaint.DeclinedJobReasonId,
                                ServiceDetailType: 4,
                                ParentSystemName: "RevisedEstimate",
                                Price: part.Price || null
                            }); }), true)
                        }); })
                    };
                    URL = "";
                    if (parentModuleName === ESystemName.Appointment) {
                        payload.AppointmentId = appointmentId;
                        URL = upsertPreviousCustomerComplaintAppointment;
                    }
                    else if (parentModuleName === ESystemName.Inspection) {
                        URL = upsertPreviousCustomerComplaintInspection;
                        payload.InspectionId = inspectionId;
                    }
                    else if (parentModuleName === ESystemName.ServiceEstimate || parentModuleName === ESystemName.Estimate || parentModuleName === ESystemName.RevisedEstimate) {
                        URL = upsertPreviousCustomerComplaintEstimate;
                        payload.EstimateId = estimateId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: URL,
                            request: payload
                        }))];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && (_response$payload5 = _response$payload5.value) !== null && _response$payload5 !== void 0 && _response$payload5.success && (response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        getSavedcustomerComplaint();
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Job items saved successfully",
                            type: "success"
                        }));
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    setDisableSaveBtn(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var disablecustomerComplaint = function (option) {
        var _savedcustomerComplai;
        var _find = savedcustomerComplaint === null || savedcustomerComplaint === void 0 || (_savedcustomerComplai = savedcustomerComplaint.data) === null || _savedcustomerComplai === void 0 ? void 0 : _savedcustomerComplai.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ComplaintId) === (option === null || option === void 0 ? void 0 : option.ComplaintId); });
        if (_find !== null && _find !== void 0 && _find.ComplaintId) {
            return true;
        }
        else {
            return false;
        }
    };
    var onDeleteCommonPopupRecording = function (blobUrl) { };
    var getServiceTypeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d4, _repairType$payload, _repairType$payload2, request, repairType, _repairType$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        ModuleEntityId: "JobCard",
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ProductId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d4 = currentJobCardData.data) === null || _currentJobCardData$d4 === void 0 ? void 0 : _currentJobCardData$d4.ProductId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "repairTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        setServiceTypeList(repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getServiceType = function (option) {
        var i = serviceTypeList === null || serviceTypeList === void 0 ? void 0 : serviceTypeList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.ServiceTypeId); });
        if (i) {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.DisplayName);
        }
        else {
            /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, "-");
        }
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setOpenImagePopup(true);
    };
    var handleClose = function (items) {
        setOpenImagePopup(false);
        setImageURL("");
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid #AFD5FF",
            borderRadius: "12px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: "flex",
        padding: 2,
        borderBottom: isOpenSection ? "1px solid #DEE4EB" : "",
        justifyContent: "space-between",
        margin: "-5px 0px -5px",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, t("Customer Complaint")), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            backgroundColor: "#EEF6FF",
            padding: "1px 6px 0px 6px",
            borderRadius: "12px",
            border: "1px solid #AFD5FF",
            justifyContent: "center",
            color: "#3697FF",
            ml: "5px"
        },
        variant: "subtitle2"
    }, jobCount)), /*#__PURE__*/ React.createElement(MuiStack, null, isOpenSection ? /*#__PURE__*/ React.createElement("img", {
        src: ArrowUPIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "CustomerComplaintClose", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }) : /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "CustomerComplaintOpen", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }))), isOpenSection && /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pr: 2
        }
    }, /*#__PURE__*/ React.createElement(List, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.map(function (option) {
        var _option$ComplaintAsso, _option$ComplaintAsso2, _option$ComplaintAsso3, _option$ComplaintAsso4, _option$imageAttachem, _option$audioDuration;
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 6
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center"
            }
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option);
            },
            disabled: disabledPreviousDeclined || disablecustomerComplaint(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || disablecustomerComplaint(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.ComplaintName,
            sx: {
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "20px"
            }
        }), showGroupItems && /*#__PURE__*/ React.createElement(MuiStack, null, option !== null && option !== void 0 && option.isOpen ? /*#__PURE__*/ React.createElement("img", {
            src: ArrowUPIcon,
            onClick: function () { return updateData(option, "groupItem"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            src: ArrowDownIcon,
            onClick: function () { return updateData(option, "groupItem"); }
        }))), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            sx: {
                pl: 6
            }
        }, (option === null || option === void 0 ? void 0 : option.isOpen) && (option === null || option === void 0 || (_option$ComplaintAsso = option.ComplaintAssociations) === null || _option$ComplaintAsso === void 0 || (_option$ComplaintAsso = _option$ComplaintAsso.Labour) === null || _option$ComplaintAsso === void 0 ? void 0 : _option$ComplaintAsso.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, option === null || option === void 0 || (_option$ComplaintAsso2 = option.ComplaintAssociations) === null || _option$ComplaintAsso2 === void 0 ? void 0 : _option$ComplaintAsso2.Labour.map(function (i, index) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    borderTop: "1px solid #DEE4EB"
                }
            }), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    backgroundColor: "#F4F7FA",
                    padding: 2,
                    borderRadius: "12px",
                    border: "1px solid #DEE4EB",
                    justifyContent: "center",
                    marginY: 1
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column'
            }, /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, i === null || i === void 0 ? void 0 : i.LabourName), /*#__PURE__*/ React.createElement(MuiStack, {
                marginLeft: 3
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6",
                color: 'secondary'
            }, option !== null && option !== void 0 && option.LabourCode ? "#".concat(option === null || option === void 0 ? void 0 : option.LabourCode) : '-'))), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    backgroundColor: "#EEF6FF",
                    padding: "3px 8px",
                    borderRadius: "12px",
                    border: "1px solid #AFD5FF",
                    justifyContent: "center",
                    color: "#3697FF",
                    ml: "5px",
                    marginRight: "2px"
                },
                variant: "subtitle2"
            }, "L"), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, "\u20B9", i === null || i === void 0 ? void 0 : i.Price)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 5
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                sx: {
                    fontWeight: 400
                },
                color: gray
            }, i === null || i === void 0 ? void 0 : i.LabourCode)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("Service type")), /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("Qty :"))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, getServiceType(i), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.Quantity)))));
        })), (option === null || option === void 0 ? void 0 : option.isOpen) && (option === null || option === void 0 || (_option$ComplaintAsso3 = option.ComplaintAssociations) === null || _option$ComplaintAsso3 === void 0 || (_option$ComplaintAsso3 = _option$ComplaintAsso3.Part) === null || _option$ComplaintAsso3 === void 0 ? void 0 : _option$ComplaintAsso3.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, option === null || option === void 0 || (_option$ComplaintAsso4 = option.ComplaintAssociations) === null || _option$ComplaintAsso4 === void 0 ? void 0 : _option$ComplaintAsso4.Part.map(function (i, index) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    borderTop: "1px solid #DEE4EB"
                }
            }), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    backgroundColor: "#F4F7FA",
                    padding: 2,
                    borderRadius: "12px",
                    border: "1px solid #DEE4EB",
                    justifyContent: "center",
                    marginY: 1
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, i === null || i === void 0 ? void 0 : i.PartName), /*#__PURE__*/ React.createElement(MuiStack, {
                marginLeft: 3
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6",
                color: 'secondary'
            }, i !== null && i !== void 0 && i.PartCode ? "#".concat(i === null || i === void 0 ? void 0 : i.PartCode) : '-')), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    backgroundColor: "#EEF6FF",
                    padding: "3px 8px",
                    borderRadius: "12px",
                    border: "1px solid #AFD5FF",
                    justifyContent: "center",
                    color: "#3697FF",
                    ml: "5px",
                    marginRight: "2px"
                },
                variant: "subtitle2"
            }, "P"), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, "\u20B9", i === null || i === void 0 ? void 0 : i.Price)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 5
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                sx: {
                    fontWeight: 400
                },
                color: gray
            }, i === null || i === void 0 ? void 0 : i.PartCode)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("Service type")), /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t(" Qty:"))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, getServiceType(i), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.Quantity)))));
        }))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t("REASON")), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "reasonItem"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "reasonItem"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1
            }
        }, getReason(option)), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12
        }, /*#__PURE__*/ React.createElement(Card, {
            variant: "outlined",
            sx: {
                borderRadius: '8px'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 1.5
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h5"
        }, t("SA observations"))), /*#__PURE__*/ React.createElement(MuiStack, {
            mt: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4"
        }, option === null || option === void 0 ? void 0 : option.Comments))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Box, null, option.imageAttachementURLs && option.imageAttachementURLs.length > 0 && /*#__PURE__*/ React.createElement(MuiStack, {
            paddingX: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: "center"
        }, (_option$imageAttachem = option.imageAttachementURLs) === null || _option$imageAttachem === void 0 ? void 0 : _option$imageAttachem.slice(0, 3).map(function (image, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
            item: true,
            key: photoIndex,
            xs: 4,
            sm: 6,
            md: 6,
            lg: 6
        }, /*#__PURE__*/ React.createElement("div", {
            className: "1st",
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: image.blobUrl,
            alt: "Image ".concat(photoIndex + 1),
            style: {
                width: '90%',
                height: '100px',
                borderRadius: '8px',
                position: 'relative',
                objectFit: 'contain',
                filter: photoIndex === 2 && option.imageAttachementURLs.length > 3 ? 'brightness(.5)' : 'none'
            },
            onClick: function () { return handleClickImage(image.blobUrl); }
        }), option.imageAttachementURLs.length > 3 && photoIndex === 2 && /*#__PURE__*/ React.createElement(Typography, {
            onClick: function () {
                setViewAllImagesList(option.imageAttachementURLs);
                setViewImages(true);
            },
            variant: "body2",
            sx: {
                position: 'absolute',
                top: '40px',
                left: '20%',
                color: '#FFFFFF',
                cursor: 'pointer'
            }
        }, t("View All")))); }))), option.audioAttachment && /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            padding: "9px",
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(AudioPlayer, {
            src: option === null || option === void 0 ? void 0 : option.audioAttachment,
            isSlider: true,
            audioDuration: (_option$audioDuration = option === null || option === void 0 ? void 0 : option.audioDuration) !== null && _option$audioDuration !== void 0 ? _option$audioDuration : 0
        }))))))));
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            marginX: 2,
            borderBottom: "1px solid #DEE4EB"
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: "flex",
            justifyContent: "end",
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        color: "primary",
        onClick: function () {
            upsertcustomerComplaint();
        },
        name: t("Save"),
        disabled: disabledPreviousDeclined || (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.length) <= 0 || (customerComplaint === null || customerComplaint === void 0 || (_customerComplaint$fi = customerComplaint.filter(function (item) { return item.isSelected; })) === null || _customerComplaint$fi === void 0 ? void 0 : _customerComplaint$fi.length) <= 0 || disableSaveBtn
    }))), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
        isOpen: viewImages,
        onClosed: function () {
            setViewImages(function (prev) { return !prev; });
            setViewAllImagesList([]);
        },
        images: viewAllImagesList
    }), openImagePopup && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: openImagePopup,
        onClose: handleClose,
        image: imageURL
    }));
};
export default DeclinedCustomerComplaint;
